import React from 'react';
import { MFDetailsPageURL } from '__utils/common-utils';
import { useMediaQuery } from 'react-responsive';
import './index.css';
import styled from 'styled-components';
import { CommonStyledComponentProps } from '__utils/type';
import upArrow from 'images/arrow-right-green.png';
import downArrow from 'images/arrow-right-red.png';
import moment from 'moment';

export const PortfolioContainer = styled.div<CommonStyledComponentProps>`
    margin-top: ${(props: any) => props.isMobile ? "16px" : "0"};
    border-radius: 8px;
    height: auto;
    background-color: transparent;
`;

interface FolioRecordProp {
    portfolioScheme: any;
    showDetail: boolean;
}
const FolioCards: React.FC<FolioRecordProp> = ({ portfolioScheme, showDetail }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const currentDate = new Date();
    
    const majorStatus = sessionStorage.getItem('majorStatus') || '';
    

    return <PortfolioContainer isMobile={isMobile}>
        <div className="folio-card">
            <div>
                <h1 className="folio-card-header-title">
                    {portfolioScheme?.metaData?.fundType == 'Open Ended Investment Company' && <a 
                        href={!majorStatus ? MFDetailsPageURL(portfolioScheme.metaData) : '#'} onClick={(e:any) => e.preventDefault()}>
                        {portfolioScheme?.metaData?.schemeShortName}</a>}
                </h1>
                {(portfolioScheme?.tagToDisplay && portfolioScheme?.tagToDisplay !== 'none') && <>
                    <p className='redemtion-sec' style={{display: 'inline-block', marginBottom: '5px'}}>{portfolioScheme?.tagToDisplay === 'all' ? <>Full redemption in progress < br /> Units : {portfolioScheme?.unitsAllocated || 0}</> : portfolioScheme?.tagToDisplay === 'both' ? <>Redemption in progress<br />Amount : ₹{portfolioScheme?.inProgressAmount || 0} <br />Units : {portfolioScheme?.inProgressUnits}</> : (portfolioScheme?.tagToDisplay !=='all' && portfolioScheme?.tagToDisplay !== 'both') && <>Redemption in progress < br /> {portfolioScheme?.tagToDisplay === 'amount' ? <>Amount : ₹{portfolioScheme?.inProgressAmount || 0} <br /></> : <>Units : {portfolioScheme?.inProgressUnits || 0}</>} </>
                    }</p>
                </>
                }
                <p className="folio-title">Folio #{portfolioScheme?.folioNo}</p>
                
                {portfolioScheme?.setupDate > currentDate && <p className='errorMsg'>NAV will be available from {moment(portfolioScheme?.setupDate).format('DD/MM/YYYY')}</p>}
                <div className='folio-flex'>
                    <p className="ft14 mt8">Total Units : {portfolioScheme?.unitsAllocated?.toFixed(2)} <br /> {portfolioScheme?.setupDate > currentDate ? null : <> NAV : {portfolioScheme?.todaysNAV?.toFixed(2)}  <span className='latestNavDate'>(As of {moment(portfolioScheme?.latestNavDateByBatch).format('DD/MM/YYYY')})</span></>}</p>
                    {showDetail && <a href={`portfolio-details?folioNo=${portfolioScheme?.folioNo}&schemeId=${portfolioScheme?.metaData?.schemeId}`} className={majorStatus ? 'disabledBtn' : 'detailsText'}>Details</a>}
                </div>
            </div>

            <div className='folio-flex mt8'>
                <div>
                    <p className='folio-card-smalltext'>Current Value</p>
                    {portfolioScheme?.setupDate > currentDate ? 'N.A' : <p className='ft13'>&#8377;{portfolioScheme?.currentValue?.toLocaleString('en-IN')}</p>}
                </div>
                {/* <div>
                    <p className='folio-card-smalltext'>Annual(XIRR) Return</p>
                    <p className='ft13'>
                        <span className={portfolioScheme?.currentValue < portfolioScheme?.amountInvested ? 'changesDown' : 'changesUp'}>{portfolioScheme?.currentValue >= portfolioScheme?.amountInvested ? '+' : '-'}{isFinite(portfolioScheme?.xirrReturn) && !isNaN(portfolioScheme?.xirrReturn) ? portfolioScheme?.xirrReturn?.toFixed(2) : 'N/A'}%</span>
                    </p>
                </div> */}
            </div>

            <div className='folio-flex mt8'>
                <div>
                    <p className='folio-card-smalltext'>Net Investment</p>
                    <p className='ft13'>&#8377; {portfolioScheme?.amountInvested?.toLocaleString('en-IN')}</p>
                </div>
                <div>
                    <p className='folio-card-smalltext'>Absolute Gains</p>
                    {portfolioScheme?.setupDate > currentDate ? 'N.A'  : <>{portfolioScheme?.returnAmount && <p className='ft13'>
                          &#8377; {portfolioScheme?.returnAmount?.toLocaleString('en-IN')}({portfolioScheme?.returnPercentage?.toFixed(2)}%)
                    </p>}</> }
                </div>
                <div>
                    <p className='folio-card-smalltext'>Today's Change</p>
                    {portfolioScheme?.setupDate > currentDate ? 'N.A' : <p className='ft13'>
                        {portfolioScheme?.todaysChange !== 0 && <img src={portfolioScheme.todaysChange > 0 ? upArrow : downArrow} alt="arrow" width="8" style={{ marginTop: '4px' }}></img>}
                        <span> &#8377; {portfolioScheme?.todaysChange?.toLocaleString('en-IN')}</span>
                    </p>}
                </div>
            </div>
        </div>


    </PortfolioContainer>;
}

export default FolioCards;
